export default __webpack_public_path__ + "6b9816b7bda44cde7e694d7ee7f14470.png";